import { createSlice } from "@reduxjs/toolkit";
import { getNotifications, updateNotificationStatus } from './thunk';
export const initialState = {
  notification: [],
  error: {}
};

const Common = createSlice({
  name: 'Common',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      state.notification = action.payload;
    });

    builder.addCase(getNotifications.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateNotificationStatus.fulfilled, (state, action) => {
      state.notification = state.notification.map((item) => item.ID === action.payload[0]?.ID ? {...item, IsRead: true} : item);
    });

    builder.addCase(updateNotificationStatus.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Common.reducer;